import React, { memo } from "react";
import Input from "./Input/Input";
import Password from "./Password/Password";
import Select from "./Select/Select";
import FileInput from "./FileInput/FileInput";
import Checkbox from "./Checkbox/Checkbox";
import FieldArray from "./FieldArray/FieldArray";
import Range from "./Range/Range";
import TextArea from "./TextArea/TextArea";
import Markdown from "./MarkdownEditor/Markdown";
import { Controller } from "react-hook-form";

const FormControl = ({ controlType, ...rest }) => {
  switch (controlType) {
    case "input":
      return <Input {...rest} />;
    case "password":
      return <Password {...rest} />;
    case "textarea":
      return <TextArea {...rest} controlType={controlType} />;
    case "select":
      return <Select {...rest} />;
    case "file":
      return <FileInput {...rest} />;
    case "checkbox":
      return <Checkbox {...rest} controlType={controlType} />;
    case "fieldArray":
      return <FieldArray  
      name={rest.name}
      control={rest.control} 
      slabFields={rest.slabFields}
    />;
    case "date":
    
      if (rest.control) {
        return (
          <Controller
          name={rest.name}                  
          control={rest.control}            
          rules={rest.validations || {}}
            render={({ field }) => (
              <Input
                {...field}
                type="date"
                placeholder={rest.placeholder || `Enter ${rest.label}`}
              />
            )}
          />
        );
      } else {
        return <Input {...rest} type="date" />;
      }
    case "range":
      return <Range {...rest} />;
    case "markdown":
      return <Markdown {...rest}/>
    default:
      return null;
  }
};

export default memo(FormControl);
